<button
  class="flex items-center justify-center w-full transition-colors px-3 py-2 gap-2 text-gray-800 rounded-xl border"
  [ngClass]="
    active() ? 'border-primary bg-primary-50' : 'border-gray-200 bg-white'
  "
  [tabindex]="0"
>
  <app-icon
    name="solar:check-circle-bold"
    [ngClass]="active() ? 'text-primary' : 'text-gray-300'"
  />
  {{ label() }}
</button>
